import * as types from './types';

export const getNotes = (payload) => {
  return {
    type: types.GET_NOTES,
    payload,
  };
};

export const getNotesSuccess = ({ variables }) => {
  return {
    type: types.GET_NOTES_SUCCESS,
    payload: variables,
  };
};

export const getNotesFail = ({ variables }) => {
  return {
    type: types.GET_NOTES_FAIL,
    payload: variables,
  };
};

export const searchNote = (payload) => {
  return {
    type: types.SEARCH_NOTES,
    payload,
  };
};

export const searchNotesSuccess = ({ variables }) => {
  return {
    type: types.SEARCH_NOTES_SUCCESS,
    payload: variables,
  };
};

export const searchNotesFail = ({ variables }) => {
  return {
    type: types.SEARCH_NOTES_FAIL,
    payload: variables,
  };
};

export const getSingleNote = ({ variables }) => {
  return {
    type: types.GET_SINGLE_NOTE,
    payload: variables,
  };
};

export const getSingleNoteSuccess = ({ variables }) => {
  return {
    type: types.GET_SINGLE_NOTE_SUCCESS,
    payload: variables,
  };
};

export const getSingleNoteFail = ({ variables }) => {
  return {
    type: types.GET_SINGLE_NOTE_FAIL,
    payload: variables,
  };
};

export const updateIndexPreferences = (variables) => {
  return {
    type: types.UPDATE_INDEX_PREFERENCES,
    payload: variables,
  };
};

export const updateIndexPreferencesSuccess = (variables) => {
  return {
    type: types.UPDATE_INDEX_PREFERENCES_SUCCESS,
    payload: variables,
  };
};

export const updateIndexPreferencesFail = (variables) => {
  return {
    type: types.UPDATE_INDEX_PREFERENCES_FAIL,
    payload: variables,
  };
};

export const updateNote = (payload) => {
  return {
    type: types.UPDATE_NOTE,
    payload,
  };
};

export const updateNoteSuccess = (payload) => {
  return {
    type: types.UPDATE_NOTE_SUCCESS,
    payload,
  };
};

export const updateNoteFail = (payload) => {
  return {
    type: types.UPDATE_NOTE_FAIL,
    payload,
  };
};

export const deleteNote = (payload) => {
  return {
    type: types.DELETE_NOTE,
    payload,
  };
};

export const deleteNoteSuccess = (payload) => {
  return {
    type: types.DELETE_NOTE_SUCCESS,
    payload,
  };
};

export const deleteNoteFail = (payload) => {
  return {
    type: types.DELETE_NOTE_FAIL,
    payload,
  };
};

export const updateUrl = (payload) => {
  return {
    type: types.UPDATE_URL,
    payload,
  };
};

export const updateUrlSuccess = (payload) => {
  return {
    type: types.UPDATE_URL_SUCCESS,
    payload,
  };
};

export const updateUrlFail = (payload) => {
  return {
    type: types.UPDATE_URL_FAIL,
    payload,
  };
};

export const saveTemplate = (payload) => {
  return {
    type: types.SAVE_TEMPLATE,
    payload,
  };
};

export const saveTemplateSuccess = (payload) => {
  return {
    type: types.SAVE_TEMPLATE_SUCCESS,
    payload,
  };
};

export const saveTemplateFail = (payload) => {
  return {
    type: types.SAVE_TEMPLATE_FAIL,
    payload,
  };
};

export const getNotesTemplates = (payload) => {
  return {
    type: types.GET_TEMPLATES,
    payload,
  };
};

export const getNotesTemplatesSuccess = (payload) => {
  return {
    type: types.GET_TEMPLATES_SUCCESS,
    payload,
  };
};

export const getNotesTemplatesFail = (payload) => {
  return {
    type: types.GET_TEMPLATES_FAIL,
    payload,
  };
};

export const reorderNoteTemplates = (payload) => {
  return {
    type: types.REORDER_NOTE_TEMPLATES,
    payload,
  };
};

export const renameNote = (payload) => {
  return {
    type: types.RENAME_NOTE,
    payload,
  };
};

export const renameNoteSuccess = (payload) => {
  return {
    type: types.RENAME_NOTE_SUCCESS,
    payload,
  };
};

export const renameNoteFail = (payload) => {
  return {
    type: types.RENAME_NOTE_FAIL,
    payload,
  };
};

export const restrictionsNote = (payload) => {
  return {
    type: types.RESTRICTIONS_NOTE,
    payload,
  };
};

export const reorderNotes = (payload) => {
  return {
    type: types.REORDER_NOTES,
    payload,
  };
};

export const reorderNotesSuccess = (payload) => {
  return {
    type: types.REORDER_NOTES_SUCCESS,
    payload,
  };
};

export const reorderNotesFail = (payload) => {
  return {
    type: types.REORDER_NOTES_FAIL,
    payload,
  };
};

export const createNote = (payload) => {
  return {
    type: types.CREATE_NOTE,
    payload,
  };
};

export const createNoteFromTemplate = (payload) => {
  return {
    type: types.CREATE_NOTE_FROM_TEMPLATE,
    payload,
  };
};

export const createNoteSuccess = (payload) => {
  return {
    type: types.CREATE_NOTE_SUCCESS,
    payload,
  };
};

export const createNoteFail = (payload) => {
  return {
    type: types.CREATE_NOTE_FAIL,
    payload,
  };
};

export const duplicateNote = (payload) => {
  return {
    type: types.DUPLICATE_NOTE,
    payload,
  };
};

export const duplicateNoteSuccess = (payload) => {
  return {
    type: types.DUPLICATE_NOTE_SUCCESS,
    payload,
  };
};

export const duplicateNoteFail = (payload) => {
  return {
    type: types.DUPLICATE_NOTE_FAIL,
    payload,
  };
};

export const getNoteGroups = (payload) => {
  return {
    type: types.GET_NOTE_GROUPS,
    payload,
  };
};

export const getNoteGroupsSuccess = (payload) => {
  return {
    type: types.GET_NOTE_GROUPS_SUCCESS,
    payload,
  };
};

export const getNoteGroupsFail = (payload) => {
  return {
    type: types.GET_NOTE_GROUPS_FAIL,
    payload,
  };
};

export const createNoteGroup = (payload) => {
  return {
    type: types.CREATE_NOTE_GROUP,
    payload,
  };
};

export const createNoteGroupSuccess = (payload) => {
  return {
    type: types.CREATE_NOTE_GROUP_SUCCESS,
    payload,
  };
};

export const createNoteGroupFail = (payload) => {
  return {
    type: types.CREATE_NOTE_GROUP_FAIL,
    payload,
  };
};

export const renameNoteGroup = (payload) => {
  return {
    type: types.RENAME_NOTE_GROUP,
    payload,
  };
};

export const renameNoteGroupSuccess = (payload) => {
  return {
    type: types.RENAME_NOTE_GROUP_SUCCESS,
    payload,
  };
};

export const renameNoteGroupFail = (payload) => {
  return {
    type: types.RENAME_NOTE_GROUP_FAIL,
    payload,
  };
};

export const deleteNoteGroup = (payload) => {
  return {
    type: types.DELETE_NOTE_GROUP,
    payload,
  };
};

export const deleteNoteGroupSuccess = (payload) => {
  return {
    type: types.DELETE_NOTE_GROUP_SUCCESS,
    payload,
  };
};

export const deleteNoteGroupFail = (payload) => {
  return {
    type: types.DELETE_NOTE_GROUP_FAIL,
    payload,
  };
};

export const reorderNoteGroup = (payload) => {
  return {
    type: types.REORDER_NOTE_GROUP,
    payload,
  };
};

export const reorderNoteGroupSuccess = (payload) => {
  return {
    type: types.REORDER_NOTE_GROUP_SUCCESS,
    payload,
  };
};

export const reorderNoteGroupFail = (payload) => {
  return {
    type: types.REORDER_NOTE_GROUP_FAIL,
    payload,
  };
};

export const updateNoteGroupView = (variables) => {
  return {
    type: types.UPDATE_NOTE_GROUP_VIEW,
    payload: variables,
  };
};

export const updateNoteGroupViewSuccess = (variables) => {
  return {
    type: types.UPDATE_NOTE_GROUP_VIEW_SUCCESS,
    payload: variables,
  };
};

export const updateNoteGroupViewFail = (variables) => {
  return {
    type: types.UPDATE_NOTE_GROUP_VIEW_FAIL,
    payload: variables,
  };
};

export const createNoteComment = (variables) => {
  return {
    type: types.CREATE_NOTE_COMMENT,
    payload: variables,
  };
};

export const createNoteCommentSuccess = (variables) => {
  return {
    type: types.CREATE_NOTE_COMMENT_SUCCESS,
    payload: variables,
  };
};

export const createNoteCommentFail = (variables) => {
  return {
    type: types.CREATE_NOTE_COMMENT_FAIL,
    payload: variables,
  };
};

export const updateNoteComment = (variables) => {
  return {
    type: types.UPDATE_NOTE_COMMENT,
    payload: variables,
  };
};

export const updateNoteCommentSuccess = (variables) => {
  return {
    type: types.UPDATE_NOTE_COMMENT_SUCCESS,
    payload: variables,
  };
};

export const updateNoteCommentFail = (variables) => {
  return {
    type: types.UPDATE_NOTE_COMMENT_FAIL,
    payload: variables,
  };
};

export const deleteNoteComment = (variables) => {
  return {
    type: types.DELETE_NOTE_COMMENT,
    payload: variables,
  };
};

export const deleteNoteCommentSuccess = (variables) => {
  return {
    type: types.DELETE_NOTE_COMMENT_SUCCESS,
    payload: variables,
  };
};

export const deleteNoteCommentFail = (variables) => {
  return {
    type: types.DELETE_NOTE_COMMENT_FAIL,
    payload: variables,
  };
};

export const createNoteTemplate = (variables) => {
  return {
    type: types.CREATE_NOTE_TEMPLATE,
    payload: variables,
  };
};

export const createNoteTemplateSuccess = ({ variables }) => {
  return {
    type: types.CREATE_NOTE_TEMPLATE_SUCCESS,
    payload: variables,
  };
};

export const createNoteTemplateFail = ({ variables }) => {
  return {
    type: types.CREATE_NOTE_TEMPLATE_FAIL,
    payload: variables,
  };
};

export const updateNoteTemplate = (variables) => {
  return {
    type: types.UPDATE_NOTE_TEMPLATE,
    payload: variables,
  };
};

export const deleteNoteTemplate = (variables) => {
  return {
    type: types.DELETE_NOTE_TEMPLATE,
    payload: variables,
  };
};

export const duplicateNoteTemplate = (variables) => {
  return {
    type: types.DUPLICATE_NOTE_TEMPLATE,
    payload: variables,
  };
};
